<template>
  <div
    class="dialog"
    :class="[connected && 'is-connected']"
    :data-id="dialog.id"
    @click="$emit('setDialog', dialog.id)"
  >
    <div class="dialog__avatar">
      <div class="dialog__avatar-image">
        <img :src="dialogAvatar" :alt="$localized(dialogUser.localized_name, dialogUser.first_name)" />
      </div>
    </div>
    <div class="dialog__content" v-if="dialog">
      <div class="dialog__title">
        <span class="dialog__title-name">
          {{ dialogTitle }}
          <div class="dialog__count" v-if="unread">{{ unread }}</div>
        </span>

        <div class="dialog__time">{{ timestamp }}</div>
      </div>
      <div class="dialog__last-msg-user">You</div>
      <div class="dialog__description" v-if="dialog.message">
        <span v-if="dialog.message.content" v-html="dialog.message.content"></span>
        <template v-else-if="dialog.message.file">
          {{ $t('chat.dialog.file') }}: {{ dialog.message.file.name }}
        </template>
        <template v-else> {{ $t('chat.dialog.new-dialog') }} </template>
      </div>
    </div>

    <div class="dialog__loader" v-if="!connected">
      <Loader :loading="true" theme="block" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { timeToTimeStamp } from '@/utils/date'
import { withUi } from '@/components/ui'
import dialogUtils from '@/mixins/dialogUtils'

export default {
  data() {
    return {
      connected: true//TODO
    }
  },
  mixins: [withUi, dialogUtils],
  props: {
    dialog: Object,
  },
  computed: {
    unread() {
      return this.dialog.message_count - this.dialog.message_read
    },
    userName() {
      const { first_name, last_name, email } = this.user

      if (first_name) {
        return `${first_name} ${last_name}`
      } else {
        return email
      }
    },
    timestamp() {
      const { message } = this.dialog

      if (message && message.created_at) {
        return timeToTimeStamp(message.created_at * 1000)
      }

      return null
    },
  },
  mounted() {
    if (this.dialog.id) {
      // console.log('connecting dialog to socket', this.dialog.id)

      const socket = this.$echo
        .private(`chat.${this.dialog.id}`)
        .listen('.presence:subscribed', (payload) => {
          this.connected = true
        })
        .listen('.chat.message.new', (payload) => {
          // console.log('echo responce on chat.message.new', payload)
          this.socketMessage(payload)
        })
        .listen('.chat.message.updated', (payload) => {
          // console.log('echo responce on chat.message.updated', payload)
          this.socketMessage(payload)
        })
        .listen('.chat.message.deleted', (payload) => {
          console.log('not working - echo responce on chat.message.deleted', payload)
          this.deleteMessageById(payload.id)
        });

    }
  },
  methods: {
    ...mapActions('chat', ['socketMessage', 'deleteMessageById']),
  },
}
</script>

<style lang="scss" scoped>
.dialog {
  position: relative;
  display: flex;
  border-radius: 10px;
  margin-bottom: 15px;
  padding: 15px;
  transition: background 0.25s ease;
  cursor: pointer;
  &:last-child {
    margin-bottom: 0;
  }
  &:hover {
    background: #FFFFFF;
    box-shadow: 0px 12px 21px 0px #B4BBC630;
  }
  &__avatar {
    position: relative;
    flex: 0 0 60px;
    max-width: 60px;
  }
  &__avatar-online {
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 3;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: $dark;
    border: 2px solid #ffffff;
    transition: background 0.25s $ease;
    pointer-events: none;
    &.online {
      background: #1ac57e;
    }
  }
  &__avatar-image {
    position: relative;
    z-index: 1;
    width: 60px;
    height: 60px;
    border-radius: 15px;
    background: #f4f4f4;
    overflow: hidden;
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center top;
    }
  }

  &__content {
    flex: 0 0 calc(100% - 60px);
    max-width: calc(100% - 60px);
    min-width: 1px;
    padding-left: 16px;
  }
  &__title {
    position: relative;
    display: flex;
    align-items: center;
  }
  &__last-msg-user {
    font-size: 15px;
    font-weight: 600;
    line-height: 18px;
    color: #003882;
  }
  &__title-name {
    display: flex;
    align-items: center;
    font-size: 15px;
    font-weight: 700;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &__count {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 16px;
    min-width: 16px;
    border-radius: 50%;
    background: #003882;
    margin-left: 4px;

    font-size: 12px;
    font-weight: 700;
    line-height: 12px;
    color: #FFFFFF;
  }
  &__time {
    flex: 0 0 auto;
    margin-left: auto;
    padding-left: 10px;
    font-size: 12px;
    text-align: right;
    color: $dark;
  }
  &__description {
    font-size: 14px;
    color: $dark;
    height: 22px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &__indicator {
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: 50%;
    background: $primary;
    color: white;

    span {
      //font-family: Gilroy;
      font-weight: bold;
      font-size: 10px;
    }
  }
  &__loader {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
    background: rgba(white, 0.5);
    .loader {
      background: transparent;
      box-shadow: none;
    }
  }
}
</style>
